import styled from 'styled-components';

export const StyledSubHeader = styled.div`
  margin-bottom: 1.75rem;
`;
